import { VApp } from 'vuetify/lib/components/VApp';
import { VMain } from 'vuetify/lib/components/VMain';
import { VOverlay } from 'vuetify/lib/components/VOverlay';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VApp,[_vm._v("\n  "+_vm._s(_vm.$nuxt.env)+"\n  "),_c('app-bar'),_vm._v(" "),_c(VMain,[_c('Nuxt')],1),_vm._v(" "),_c('app-footer'),_vm._v(" "),_c('notification'),_vm._v(" "),_c(VOverlay,{staticClass:"d-flex justify-center",attrs:{"value":_vm.isLoading}},[_c(VProgressCircular,{attrs:{"indeterminate":"","color":"primary","size":60}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }